var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundupLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 204,
    viewBox: "0 0 222 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M213.205 40.6497C203.814 22.8646 191.498 12.7876 175.361 10.0492C146.45 5.14275 130.256 16.6293 110.562 18.0746C90.8691 19.52 80.1701 7.56337 62.6218 2.21413C48.9246 -1.96119 21.4821 5.7183 12.6122 24.2242C3.94291 42.4976 -4.11878 59.3708 7.8459 83.0975C19.5783 106.624 40.3234 113.593 54.067 137.842C67.8106 162.092 70.1387 185.163 87.0108 194.915C104.703 205.14 145.402 208.422 166.931 186.968C184.248 169.712 180.555 142.864 195.933 124.098C211.311 105.332 218.018 96.5498 219.159 84.3631C220.736 67.5156 220.878 55.1829 213.205 40.6497Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundupLasso);
export default __webpack_public_path__ + "static/media/roundup-lasso.da36becf7008bd345dbc523b68344cc9.svg";
export { ForwardRef as ReactComponent };